import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { loginAdmin } from '../adminsApi';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    const storedUser = localStorage.getItem('admin_user');
    if (token && storedUser) {
      setUser(JSON.parse(storedUser));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      // Use new admin login endpoint
      const res = await loginAdmin(username, password);
      const { user, token, success, errorMessage, message } = res;
      if (success && user && user.Role === 'Admin') {
        localStorage.setItem('admin_token', token || '');
        localStorage.setItem('admin_user', JSON.stringify(user));
        window.dispatchEvent(new Event('adminUserChanged'));
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        setUser(user);
        return true;
      } else {
        throw new Error(errorMessage || message || 'Invalid credentials');
      }
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    window.dispatchEvent(new Event('adminUserChanged'));
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
